interface LoginScreenProps {
  onSignIn: () => void
  isLoading: boolean
}

export function LoginScreen({ onSignIn, isLoading }: LoginScreenProps) {
  return (
    <div class="login-screen">
      <div class="login-card">
        <img
          src="/splash_icon_colorful.png"
          alt="PiPar"
          style={{ width: 96, height: 96, marginBottom: 16, display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
        />
        <h1>Meet PiPar</h1>
        <p>Your Digital Business Partner</p>
        <button class="btn btn-primary" onClick={onSignIn} disabled={isLoading}>
          {isLoading ? 'Signing in...' : 'Sign in with Google'}
        </button>
      </div>
    </div>
  )
}
